import { render, staticRenderFns } from "./textAreaType.vue?vue&type=template&id=9bdcb1ba"
import script from "./textAreaType.vue?vue&type=script&lang=js"
export * from "./textAreaType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports